import React, { Fragment, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory, useParams } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Grid, IconButton, CircularProgress } from '@material-ui/core';
import PageTemplate from '../../common/page-template/PageTemplate';
import PageTemplateDashboard from '../../common/page-template/PageTemplateDashboard';
import PageTemplateHeader, {
  PageTemplateHeaderActions
} from '../../common/page-template/PageTemplateHeader';
import StatusLabel from '../../common/StatusLabel';
import JiraStatusActions from './cards/JiraStatusActions';
import JiraDetailCard from './cards/JiraDetailCard';
import JiraIdCard from './cards/JiraIdCard';
import JiraPriorityCard from './cards/JiraPriorityCard';
import JiraEffortCard from './cards/JiraEffortCard';
import JiraStatusCard from './cards/JiraStatusCard';
import JiraAttachmentCard from './cards/JiraAttachmentCard';
import JiraPeopleCard from './cards/JiraPeopleCard';
import JiraDueDateCard from './cards/JiraDueDateCard';
import { useGetJiraIssue, convertJiraStatus } from './Jira.hooks';

const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
  .status-container {
    display: flex;
    margin-top: 5px;
    margin-left: 50px;
  }
  .title-container {
    display: inline-block;
  }
  .back-icon {
    float: left;
    margin-top: 3px;
    margin-right: 0px;
  }
  .title-text {
    margin-top: 12px;
  }
`;

const LoadingContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const getTapValue = (path: string) => {
  const array = path.split('/');
  return array[array.length - 1];
};

export const JiraDetailPage: React.FC = () => {
  const history = useHistory();
  const tabValue = getTapValue(history.location.pathname);
  const { issueId } = useParams<{ issueId?: string }>();
  const [issue, setIssue] = useState<any>();
  const [{ data }, getIssue] = useGetJiraIssue(issueId ? issueId : '');
  const [issueStatus, setIssueStatus] = useState('');

  useEffect(() => {
    getIssue();
  }, [getIssue]);

  useEffect(() => {
    data && setIssue(data);
  }, [data, issueId]);

  useEffect(() => {
    issue && setIssueStatus(issue.fields.status.name);
  }, [issue]);

  // if (!['overview', 'traceability', 'audit'].includes(tabValue)) {
  //return <Redirect to={`/portal/jira/${issueId}/overview`} />;
  // }

  return (
    <PageTemplate>
      {issue ? (
        <Fragment>
          <PageTemplateHeader>
            <StyledTitle>
              <div className='title-container'>
                <IconButton
                  className='back-icon'
                  color='inherit'
                  onClick={() => history.goBack()}
                >
                  <ArrowBackIcon />
                </IconButton>
                <h2 className='title-text'>{issue && issue.key}</h2>
              </div>
              {issue && (
                <div className='status-container'>
                  <StatusLabel status={convertJiraStatus(issueStatus)} />
                </div>
              )}
            </StyledTitle>
            <PageTemplateHeaderActions flex>
              {issue && (
                <JiraStatusActions
                  issue={issue}
                  onChange={status => setIssueStatus(status)}
                />
              )}
            </PageTemplateHeaderActions>
          </PageTemplateHeader>
          {/* <PageTemplateNav>
            <Tabs
              variant='scrollable'
              indicatorColor='primary'
              scrollButtons='auto'
              value={getTapValue(history.location.pathname)}
            >
              <Tab
                component={Link}
                label='Overview'
                value='overview'
                to='./overview'
              />
              <Tab
                component={Link}
                label='Traceability'
                value='traceability'
                to='./traceability'
              />
              <Tab
                component={Link}
                label='Audit Log'
                value='audit'
                to='./audit'
              />
            </Tabs>
          </PageTemplateNav> */}
          <PageTemplateDashboard>
            <Grid container spacing={3}>
              <Grid item xs={12} md={7}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <JiraIdCard issue={issue} />
                  </Grid>
                  <Grid item xs={12}>
                    <JiraDetailCard issue={issue} />
                  </Grid>
                  <Grid item xs={12}>
                    <JiraPriorityCard issue={issue} />
                  </Grid>
                  <Grid item xs={12}>
                    <JiraEffortCard issue={issue} />
                  </Grid>
                  <Grid item xs={12}>
                    <JiraAttachmentCard issue={issue} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={5}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <JiraStatusCard issue={issue} />
                  </Grid>
                  <Grid item xs={12}>
                    <JiraPeopleCard issue={issue} />
                  </Grid>
                  <Grid item xs={12}>
                    <JiraDueDateCard issue={issue} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* <Switch>
              <Route exact path='/portal/jira/:issueId/overview'>
                {issue && <JiraTabOverview issue={issue} />}
              </Route>
              <Route exact path='/portal/jira/:issueId/traceability'>
                {issue && <JiraTabTraceability />}
              </Route>
              <Route exact path='/portal/jira/:issueId/audit'>
                {issue && <JiraTabAuditLog />}
              </Route>
            </Switch> */}
          </PageTemplateDashboard>
        </Fragment>
      ) : (
        <LoadingContainer>
          <CircularProgress />
        </LoadingContainer>
      )}
    </PageTemplate>
  );
};

export default JiraDetailPage;
